<div class="container">
    <div class="row">
        <div class="xs-col-12">
            <p>
                This is a demo page to demonstrate api calls while logged in.
            </p>
            <p>
                <button type="button" class="btn btn-primary" (click)="callApi()">Call API</button>
            </p>
            <p style="white-space: pre; font-size:0.8em;" *ngIf="identityJson">
                {{ identityJson | json }}
            </p>
        </div>
    </div>
</div>
